import React from "react"
import Twitter from "../../assets/twitter-x.svg"
import Linkedin from "../../assets/Linkedin.svg"
import Instagram from "../../assets/Instagram.svg"

export default [
  {
    icon: <Twitter />,
    url: 'https://twitter.com/jmfinnwealth',
    ariaLabel: "Twitter"
  },
  {
    icon: <Linkedin />,
    url: 'https://www.linkedin.com/company/144983/',
    ariaLabel: "Linkedin"
  },
  {
    icon: <Instagram />,
    url: 'https://www.instagram.com/jmfinnwealth/',
    ariaLabel: "Instagram"
  },
]